import * as React from "react";
import * as ReactDOM from "react-dom";

interface IOnChanged{
    (checked:boolean, value:string):void
}

interface ICheckboxProps {
    defaultChecked:boolean
    label:string
    value:string
    checkedIconClass:string
    notCheckedIconClass:string
    radiobuttonValue?:string
    disabled?:boolean
    forceDefaultChecked?:boolean
    onChange?:IOnChanged
    className?:string
    checkBoxStyle?:any
}

interface ICheckboxState {
    checked:boolean;
    radiobuttonMode:boolean
}

export class Checkbox extends React.Component<ICheckboxProps, ICheckboxState>{
    private checked:boolean;
  	constructor(props:ICheckboxProps){
  		super(props);
  		this.state = this.getInitState();
    }


	protected getInitState():any{
        var radiobuttonMode:boolean = false;
        if ( this.props.radiobuttonValue !== undefined ) {
            radiobuttonMode = true;
        }
        this.checked = this.props.defaultChecked;
		return {
            checked: this.checked,
            radiobuttonMode: radiobuttonMode
        };
	}

    private checkboxChangeHandler(evt): void {
        evt.preventDefault();

        if ( this.props.disabled !== undefined && this.props.disabled === true ) {
            return;
        }
        this.checked = !this.state.checked;

        if ( this.props.onChange !== undefined) {
            this.props.onChange(this.checked, this.props.value);
        }else{
            this.setState({
                checked: this.checked
            });
        }
    }


    render() {
        var className:string = 'checkbox';
        if ( this.props.className !== undefined ) {
            className += ' ' + this.props.className
        }
        if ( this.props.disabled !== undefined && this.props.disabled === true ) {
            className += ' disabled';
        }
        var checked:boolean = this.checked;
        if ( this.props.forceDefaultChecked !== undefined) {
            checked = this.props.defaultChecked;
        }


        if ( this.state.radiobuttonMode === true ) {

            if ( this.props.radiobuttonValue !== this.props.value ) {
                checked = false;
            }
        }
        return (
  			<div className={className}>
                <label onClick={ (e) => this.checkboxChangeHandler(e) } >
                    <input type="checkbox" value={ this.props.value } readOnly
                     checked={ checked } style={{ display: "none"}}/>

                        { checked === true ?<span className="check_box" style={this.props.checkBoxStyle!==undefined?this.props.checkBoxStyle:{}}>
                             { this.props.checkedIconClass !== null?<span className={ this.props.checkedIconClass }></span>:'' }
                        </span>:<span className="check_box" style={this.props.checkBoxStyle!==undefined?this.props.checkBoxStyle:{}}>{ this.props.notCheckedIconClass !== null?<span className={ this.props.notCheckedIconClass }></span>:'' }</span> }
                    <span className="label">
                        <span>
                            { this.props.children !== undefined?this.props.children:this.props.label }
                        </span>
                    </span>

                </label>
  			</div>
        );
    }
}
export class InitCheckbox {
    constructor() {
        var div: HTMLDivElement = document.getElementById('checkbox_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.render(<Checkbox
                defaultChecked={ true }
                label="Teset checkbox"
                value="1"
                checkedIconClass="ion-ios-checkmark-circle-outline"
                disabled={true}
                notCheckedIconClass={null} />, div);
        }
    }
}
